<template>
  <div class="info-manage-supplier">
    <el-tabs v-model="activeTab" class="info-tabs">
      <el-tab-pane v-for="(item, index) in tabList" :key="index" :label="item.label" :name="item.name">
        <span slot="label">{{ item.label }}</span>
      </el-tab-pane>
    </el-tabs>
    <div class="bar-line"></div>
    <div class="info-table">
      <!-- 表头 -->
      <div class="table-row table-head">
        <div class="cell cell-publisher">发布人</div>
        <div class="cell cell-image">产品图</div>
        <div class="cell cell-name">产品名称</div>
        <div class="cell cell-category">产品品类</div>
        <div class="cell cell-company">公司名称</div>
        <div class="cell cell-contact">联系方式</div>
        <div class="cell cell-remark">备注</div>
        <div class="cell cell-status">订单状态</div>
        <div class="cell cell-action">操作</div>
      </div>

      <!-- 订单分组列表 -->
      <div class="order-list" @scroll="handleScroll" v-if="orderList.length != 0">
        <div v-for="(order, index) in orderList" :key="index" class="order-group">
          <div class="order-id">ID: {{ order.demandId }}</div>
          <div class="table-row table-body">
            <div class="cell cell-publisher">
              <img class="avatar" :src="order.headPortrait || avatarImg" alt="avatar" />
              <span class="publisher-name">{{ order.userName }}</span>
            </div>
            <div class="cell cell-image">
              <img v-if="order.productPicture != ''" :src="getFirstImage(order.productPicture)" class="product-img" />
              <div v-else>无</div>
            </div>
            <div class="cell cell-name">{{ order.productName || "无" }}</div>
            <!-- <div class="cell cell-category">{{ typeLabel(order.type) }}</div> -->
            <div class="cell cell-category">{{ order.productType || "无" }}</div>
            <div class="cell cell-company">{{ order.enterpriseName || "无" }}</div>
            <div class="cell cell-contact">{{ order.relationPhone || "无" }}</div>
            <div class="cell cell-remark">{{ order.remark || "无" }}</div>
            <!-- 类型(apply_verify=验样,bidding=竞价) -->
            <div class="cell cell-status">{{ applyStatusLabel(order.applyStatus, order.type) }}</div>
            <div class="cell cell-action">
              <button class="op-btn" v-if="order.applyStatus == 'apply' || order.applyStatus == 'bidding'" @click="openTerminateDialog(order)">终止</button>
              <button class="op-btn" v-if="order.applyStatus == 'wait_bidding'" @click="openBiddingDialog(order)">提交竞价</button>
              <button class="op-btn" v-if="order.applyStatus == 'bidding'" @click="openBiddingDialog2(order)">修改竞价</button>
              <button
                class="op-btn"
                v-if="order.applyStatus == 'wait_bidding' || order.applyStatus == 'bidding' || order.applyStatus == 'repurchase_bidding'"
                @click="openOrderDetailDialog(order)"
              >
                订单详情
              </button>
              <button class="op-btn" @click="jumpInfo(order)">详情查看</button>
              <!-- 类型(apply_verify=验样,bidding=竞价) -->
              <button class="op-btn" v-if="order.type == 'apply_verify'" @click="removeApplyVerifyFun(order)">删除</button>
              <button class="op-btn" v-if="order.type == 'bidding'" @click="removeBiddingFun(order)">删除</button>
            </div>
          </div>
        </div>
        <div class="loading-more">
          <span v-if="loadingMore">加载中...</span>
          <span v-else-if="noMore">— 没有更多了 —</span>
        </div>
      </div>
      <div v-else>
        <el-empty description="没有更多数据"></el-empty>
      </div>
    </div>

    <!-- 终止确认弹窗 -->
    <ResultDialog
      :visible.sync="showTerminateDialog"
      title="终止提示"
      :subtitle="currentTerminateOrder && currentTerminateOrder.applyStatus === 'bidding' ? '你确定要终止竞价吗？' : '你确定要终止验样申请吗？'"
      :icon-src="require('@/assets/image/question-mark.png')"
      :dialog-width="'420px'"
      confirm-text="确定"
      cancel-text="取消"
      @confirm="handleTerminateConfirm"
      @cancel="showTerminateDialog = false"
      @close="closeTerminateDialog"
      btnMarginTop="35px"
    >
      <template #default>
        <div style="padding: 0 23px">
          <el-input resize="none" style="font-family: initial; font-size: 16px" type="textarea" :rows="6" placeholder="请输入终止理由" v-model="terminateReason"></el-input>
        </div>
      </template>
    </ResultDialog>

    <!-- 提交/修改竞价弹窗 -->
    <el-dialog
      top="8vh"
      :append-to-body="true"
      :visible.sync="showBiddingDialog"
      width="808px"
      :show-close="false"
      :close-on-click-modal="false"
      custom-class="publish-demand-dialog"
      @close="handleCloseBiddingDialog"
    >
      <div class="publish-modal">
        <img class="publish-close-btn" src="@/assets/image/close1-icon.png" @click="showBiddingDialog = false" />
        <h3 class="publish-title">{{ isEditBiddingMode ? "修改竞价" : "提交竞价" }}</h3>
        <div class="publish-form">
          <div class="form-item">
            <span class="form-label">产品名称<i class="required-star">*</i></span>
            <el-input v-model="biddingForm.productName" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">产品类别<i class="required-star">*</i></span>
            <el-select v-model="biddingForm.productTypeId" placeholder="请选择" class="form-select" @change="productTypeIdChange">
              <!-- <el-option v-for="item in productTypes" :key="item.value" :label="item.label" :value="item.value" /> -->
              <el-option v-for="item in productTypeList" :key="item.productTypeId" :label="item.typeName" :value="item.productTypeId" />
            </el-select>
          </div>
          <div class="form-item">
            <span class="form-label">数量</span>
            <el-input type="number" v-model="biddingForm.number" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">联系人</span>
            <el-input v-model="biddingForm.relationName" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">联系方式<i class="required-star">*</i></span>
            <el-input v-model="biddingForm.relationPhone" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">交货期限</span>
            <el-date-picker v-model="biddingForm.deliveryTime" type="date" placeholder="请选择" class="form-date" value-format="yyyy-MM-dd" />
          </div>
          <div class="form-item">
            <span class="form-label">付款方式</span>
            <el-input v-model="biddingForm.payMethod" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">产品质量</span>
            <el-input v-model="biddingForm.productQuality" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">单价<i class="required-star">*</i></span>
            <el-input type="number" v-model="biddingForm.price" placeholder="请输入单价" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">总价<i class="required-star">*</i></span>
            <el-input type="number" v-model="biddingForm.totalAmount" placeholder="请输入优惠总价" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label" style="line-height: 40px">产品图片</span>
            <ImageUpload v-model="biddingForm.productPicture" :multiple="true" :limit="9" size="120px" dir="product" />
          </div>
          <div class="form-item">
            <span class="form-label" style="line-height: 40px">订单信息</span>
            <el-input v-model="biddingForm.orderInfo" type="textarea" placeholder="请输入订单信息" class="form-textarea" :rows="4" />
          </div>
          <div class="form-item">
            <span class="form-label" style="line-height: 40px">备注</span>
            <el-input :maxlength="1000" show-word-limit v-model="biddingForm.biddingRemark" type="textarea" placeholder="说点详细信息吧" class="form-textarea" :rows="4" />
          </div>
        </div>
        <div style="text-align: center">
          <button class="publish-submit-btn" @click="submitBidding">{{ isEditBiddingMode ? "修改竞价" : "提交竞价" }}</button>
        </div>
      </div>
    </el-dialog>

    <!-- 订单详情弹窗 -->
    <el-dialog
      top="8vh"
      :append-to-body="true"
      :visible.sync="showOrderDetailDialog"
      width="808px"
      :show-close="false"
      :close-on-click-modal="false"
      custom-class="publish-demand-dialog"
      @close="orderDetailInfo = {}"
    >
      <div class="publish-modal" style="padding-bottom: 56px">
        <img class="publish-close-btn" src="@/assets/image/close1-icon.png" @click="showOrderDetailDialog = false" />
        <h3 class="publish-title">订单详情</h3>
        <div class="order-detail-grid">
          <div class="detail-item">
            <span class="detail-label">产品名称：</span>
            <span class="detail-value">{{ orderDetailInfo.productName || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">产品类别：</span>
            <span class="detail-value">{{ orderDetailInfo.productType || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">数量：</span>
            <span class="detail-value">{{ orderDetailInfo.number || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">联系人：</span>
            <span class="detail-value">{{ orderDetailInfo.relationName || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">联系方式：</span>
            <span class="detail-value">{{ orderDetailInfo.relationPhone || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">交货期限：</span>
            <span class="detail-value">{{ orderDetailInfo.deliveryTime || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">付款方式：</span>
            <span class="detail-value">{{ orderDetailInfo.payMethod || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">产品质量：</span>
            <span class="detail-value">{{ orderDetailInfo.productQuality || "无" }}</span>
          </div>
          <div class="detail-item" style="width: 100%">
            <span class="detail-label">订单信息：</span>
            <span class="detail-value">{{ orderDetailInfo.orderInfo || "无" }}</span>
          </div>
          <div class="detail-item" style="width: 100%">
            <span class="detail-label">备注：</span>
            <span class="detail-value">{{ orderDetailInfo.orderRemark || "无" }}</span>
          </div>
          <div class="detail-item" style="width: 100%">
            <span class="detail-label">产品图片：</span>
            <span class="detail-value">
              <template v-if="orderDetailPictureList.length > 0">
                <el-image
                  v-for="(src, idx) in orderDetailPictureList"
                  :key="idx"
                  class="order-detail-img"
                  :src="src"
                  :preview-src-list="orderDetailPictureList"
                  fit="cover"
                />
              </template>
              <span v-else>无</span>
            </span>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getSupplierRecordInfo,
  getDemandDetail,
  getBiddingDetail,
  submitBidding as submitBiddingApi,
  editBidding,
  closeApplyVerify,
  closeBidding,
  getMyProductType,
  removeApplyVerify,
  removeBidding,
} from "@/api/demand";
import { getDictData } from "@/api";
import ImageUpload from "@/components/ImageUpload.vue";
import ResultDialog from "@/components/ResultDialog.vue";
import { resolveFileUrl } from "@/utils/oss";

export default {
  name: "InfoManageSupplier",
  components: {
    ImageUpload,
    ResultDialog,
  },
  data() {
    return {
      avatarImg: require("@/assets/image/avatar.png"),
      defaultProductImg: require("@/assets/image/loginPageBackground.png"),
      loading: false,
      activeTab: " ",
      // 状态(all=全部,apply=验样中,wait_bidding=待竞价,bidding=竞价中,pass=已完成,repurchase_bidding=复购竞价,verify_fail=验样失败,bidding_fail=竞价失败,close=已终止)
      tabList: [
        { name: "all", label: "全部" },
        { name: "apply", label: "验样中" },
        { name: "wait_bidding", label: "待竞价" },
        { name: "bidding", label: "竞价中" },
        { name: "pass", label: "已完成" },
        { name: "repurchase_bidding", label: "复购竞价" },
        { name: "verify_fail", label: "验样失败" },
        { name: "bidding_fail", label: "竞价失败" },
        { name: "close", label: "已终止" },
      ],
      orderList: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      noMore: false,
      loadingMore: false,
      // 终止弹窗
      showTerminateDialog: false,
      terminateReason: "",
      currentTerminateOrder: null,
      // 订单详情弹窗
      showOrderDetailDialog: false,
      orderDetailInfo: {},
      // 竞价弹窗
      showBiddingDialog: false,
      isEditBiddingMode: false,
      currentOrderDetail: {},
      productTypes: [],
      productTypeList: [],
      biddingForm: {
        demandId: "",
        demandOrderId: "",
        productName: "",
        productType: "",
        productTypeId: "",
        number: "",
        relationName: "",
        relationPhone: "",
        deliveryTime: "",
        payMethod: "",
        productQuality: "",
        price: "",
        totalAmount: "",
        productPicture: [],
        orderInfo: "",
        biddingRemark: "",
      },
    };
  },
  computed: {
    orderDetailPictureList() {
      if (!this.orderDetailInfo || !this.orderDetailInfo.productPicture) return [];
      const raw = this.orderDetailInfo.productPicture;
      const list = Array.isArray(raw) ? raw.filter(Boolean) : String(raw).split(",").filter(Boolean);
      return list.map((u) => resolveFileUrl(u));
    },
  },
  created() {
    // this.fetchDict();
  },
  mounted() {
    if (this.$route.query.route) {
      this.activeTab = this.$route.query.route;
    } else {
      this.activeTab = "all";
    }

    this.getProductTypeListFun();
  },
  methods: {
    /** 查看采购方发布的订单详情（待竞价 / 竞价中） */
    async openOrderDetailDialog(order) {
      if (!order || !order.demandId) {
        this.$message.warning("缺少需求信息");
        return;
      }
      try {
        const res = await getDemandDetail(order.demandId);
        if (res.code != 200 || !res.data?.demandOrder) {
          this.$message.warning(res.msg || "暂无订单信息");
          return;
        }
        this.orderDetailInfo = { ...res.data.demandOrder };
        this.showOrderDetailDialog = true;
      } catch (error) {
        console.error("获取订单详情失败：", error);
        this.$message.error(error.message || "获取订单详情失败");
      }
    },
    removeApplyVerifyFun(row) {
      this.$confirm("确认是否删除？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          removeApplyVerify(row.applyVerifyId).then(() => {
            console.log(row.applyVerifyId);
            this.$message.success("删除成功");

            // 刷新列表
            this.pageNum = 1;
            this.orderList = [];
            this.noMore = false;
            this.getSupplierRecordInfoFun(this.activeTab);
          });
        })
        .catch(() => {});
    },
    removeBiddingFun(row) {
      this.$confirm("确认是否删除？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          removeBidding(row.biddingId).then(() => {
            console.log(row.biddingId);
            this.$message.success("删除成功");

            // 刷新列表
            this.pageNum = 1;
            this.orderList = [];
            this.noMore = false;
            this.getSupplierRecordInfoFun(this.activeTab);
          });
        })
        .catch(() => {});
    },
    productTypeIdChange(id) {
      this.productTypeList.forEach((item) => {
        if (item.productTypeId == id) {
          this.biddingForm.productType = item.typeName;
        }
      });
    },

    getProductTypeListFun() {
      getMyProductType().then((res) => {
        this.productTypeList = res.rows;
      });
    },

    jumpInfo(row) {
      this.$router.push({
        name: "RequirementDetails",
        query: {
          demandId: row.demandId,
          type: row.type, //type (apply_verify=验样,bidding=竞价)
          biddingIdAD: row.biddingId || "", // 竞价id
        },
      });
    },
    async getSupplierRecordInfoFun(type) {
      const isFirstPage = this.pageNum === 1;
      if (isFirstPage) {
        this.loading = true;
      } else {
        this.loadingMore = true;
      }
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        status: type,
      };
      const res = await getSupplierRecordInfo(params);
      if (res.code == 200) {
        this.loading = false;
        this.loadingMore = false;
        if (isFirstPage) {
          this.orderList = res.rows;
        } else {
          this.orderList = this.orderList.concat(res.rows);
        }
        this.total = res.total || 0;
        this.noMore = res.rows.length < this.pageSize;
      }
    },
    handleScroll(e) {
      const { scrollTop, clientHeight, scrollHeight } = e.target;
      if (scrollTop + clientHeight >= scrollHeight - 10 && !this.loadingMore && !this.noMore) {
        this.pageNum++;
        this.getSupplierRecordInfoFun(this.activeTab);
      }
    },
    /** 获取逗号分隔图片字符串中的第一张 */
    getFirstImage(productPicture) {
      if (!productPicture) return "";
      const arr = productPicture.split(",");
      return arr[0] || "";
    },
    /** 申请类型中文映射 */
    typeLabel(type) {
      const map = { apply_verify: "验样", bidding: "竞价" };
      return map[type] || type || "-";
    },
    /** 申请状态中文映射 */
    applyStatusLabel(status, type) {
      let typeName = type == "apply_verify" ? "验样" : "竞价";
      // type类型(apply_verify=验样,bidding=竞价)
      const map = {
        apply: typeName + "已申请",
        bidding: "已竞价",
        pass: typeName + "通过",
        not_pass: typeName + "未通过",
        close: typeName + "终止",
        wait_bidding: "待竞价",
        repurchase_bidding: "复购竞价",
        verify_fail: typeName + "失败", // 验样失败
        bidding_fail: typeName + "失败", // 竞价失败
      };
      return map[status] || status || "-";
    },
    /** 打开终止弹窗 */
    openTerminateDialog(order) {
      this.currentTerminateOrder = order;
      this.terminateReason = "";
      this.showTerminateDialog = true;
    },
    /** 关闭终止弹窗后清空 */
    closeTerminateDialog() {
      this.terminateReason = "";
      this.currentTerminateOrder = null;
    },
    /** 终止确认 */
    async handleTerminateConfirm() {
      if (!this.terminateReason || !this.terminateReason.trim()) {
        this.$message.warning("请输入终止理由");
        return;
      }
      const order = this.currentTerminateOrder;
      try {
        const res = await getDemandDetail(order.demandId);
        if (res.code != 200) {
          this.$message.error(res.msg || "获取详情失败");
          return;
        }
        const detail = res.data;
        if (order.applyStatus === "bidding") {
          const biddingId = detail?.bidding?.biddingId;
          if (!biddingId) {
            this.$message.error("未获取到竞价ID");
            return;
          }
          const closeRes = await closeBidding({ biddingId, closeExplain: this.terminateReason });
          if (closeRes.code == 200) {
            this.showTerminateDialog = false;
            this.$message.success("已终止竞价");
          } else {
            this.$message.error(closeRes.msg || "终止竞价失败");
            return;
          }
        } else {
          const applyVerifyId = detail?.applyVerify?.applyVerifyId;
          if (!applyVerifyId) {
            this.$message.error("未获取到验样申请ID");
            return;
          }
          const closeRes = await closeApplyVerify({ applyVerifyId, closeExplain: this.terminateReason });
          if (closeRes.code == 200) {
            this.showTerminateDialog = false;
            this.$message.success("已终止验样申请");
          } else {
            this.$message.error(closeRes.msg || "终止验样失败");
            return;
          }
        }
        // 刷新列表
        this.pageNum = 1;
        this.orderList = [];
        this.noMore = false;
        this.getSupplierRecordInfoFun(this.activeTab);
      } catch (error) {
        console.error("终止操作失败：", error);
        this.$message.error(error.message || "操作失败");
      }
    },
    /** 获取数据字典 */
    fetchDict() {
      getDictData("app_product_type").then((res) => {
        this.productTypes = (res.data || []).map((item) => ({
          label: item.dictLabel,
          value: item.dictValue,
        }));
      });
    },
    /** 打开提交竞价弹窗 */
    async openBiddingDialog(order) {
      this.resetBiddingForm();
      let userRes = JSON.parse(localStorage.getItem("userRes"));
      this.biddingForm.relationName = userRes.relationName || "";
      this.biddingForm.relationPhone = userRes.relationPhone || "";
      this.biddingForm.productName = order.productName || "";
      this.biddingForm.productTypeId = order.productTypeId || "";
      this.biddingForm.productType = order.productType || "";

      this.isEditBiddingMode = false;
      this.biddingForm.demandId = order.demandId;
      try {
        const res = await getDemandDetail(order.demandId);
        if (res.code == 200) {
          this.currentOrderDetail = res.data;
        }
      } catch (e) {
        console.error("获取需求详情失败", e);
      }
      this.showBiddingDialog = true;
    },
    /** 打开修改竞价弹窗 */
    async openBiddingDialog2(order) {
      this.resetBiddingForm();
      this.isEditBiddingMode = true;
      this.biddingForm.demandId = order.demandId;
      try {
        const res = await getDemandDetail(order.demandId);
        if (res.code == 200) {
          this.currentOrderDetail = res.data;
          // 回显竞价表单
          const biddingId = res.data?.bidding?.biddingId;
          if (biddingId) {
            const bRes = await getBiddingDetail(biddingId);
            if (bRes.code == 200) {
              const d = bRes.data;
              this.biddingForm.productName = d.productName;
              this.biddingForm.productType = d.productType;
              this.biddingForm.productTypeId = d.productTypeId;
              this.biddingForm.number = d.number;
              this.biddingForm.relationName = d.relationName;
              this.biddingForm.relationPhone = d.relationPhone;
              this.biddingForm.deliveryTime = d.deliveryTime;
              this.biddingForm.payMethod = d.payMethod;
              this.biddingForm.productQuality = d.productQuality;
              this.biddingForm.price = d.price;
              this.biddingForm.totalAmount = d.totalAmount;
              this.biddingForm.productPicture = d.productPicture ? String(d.productPicture).split(",").filter(Boolean) : [];
              this.biddingForm.orderInfo = d.orderInfo;
              this.biddingForm.biddingRemark = d.biddingRemark;
            }
          }
        }
      } catch (e) {
        console.error("获取竞价详情失败", e);
      }
      this.showBiddingDialog = true;
    },
    /** 关闭竞价弹窗 */
    handleCloseBiddingDialog() {
      this.showBiddingDialog = false;
      this.resetBiddingForm();
    },
    /** 重置竞价表单 */
    resetBiddingForm() {
      this.biddingForm = {
        demandId: "",
        demandOrderId: "",
        productName: "",
        productType: "",
        productTypeId: "",
        number: "",
        relationName: "",
        relationPhone: "",
        deliveryTime: "",
        payMethod: "",
        productQuality: "",
        price: "",
        totalAmount: "",
        productPicture: [],
        orderInfo: "",
        biddingRemark: "",
      };
    },
    /** 提交/修改竞价 */
    async submitBidding() {
      if (!this.biddingForm.productName || !this.biddingForm.productName.trim()) {
        this.$message.warning("请填写产品名称");
        return;
      }
      if (!this.biddingForm.productTypeId) {
        this.$message.warning("请选择产品类别");
        return;
      }
      if (!this.biddingForm.relationPhone || !this.biddingForm.relationPhone.trim()) {
        this.$message.warning("请填写联系方式");
        return;
      }
      if (!/^1[3-9]\d{9}$/.test(this.biddingForm.relationPhone)) {
        this.$message.warning("请输入正确的手机号");
        return;
      }
      if (!this.biddingForm.price) {
        this.$message.warning("请填写单价");
        return;
      }
      if (!this.biddingForm.totalAmount || !String(this.biddingForm.totalAmount).trim()) {
        this.$message.warning("请填写总价");
        return;
      }
      const isEdit = this.isEditBiddingMode;
      try {
        const params = {
          ...this.biddingForm,
          demandOrderId: this.currentOrderDetail.demandOrder?.demandOrderId,
          serialNumber: this.currentOrderDetail.demandOrder?.serialNumber,
          productPicture: Array.isArray(this.biddingForm.productPicture) ? this.biddingForm.productPicture.join(",") : this.biddingForm.productPicture,
        };
        if (isEdit) {
          params.biddingId = this.currentOrderDetail.bidding?.biddingId;
        }
        const res = isEdit ? await editBidding(params) : await submitBiddingApi(params);
        if (res.code == 200) {
          this.showBiddingDialog = false;
          this.$message.success(isEdit ? "修改竞价成功" : "提交竞价成功");
          this.resetBiddingForm();
          // 刷新列表
          this.pageNum = 1;
          this.orderList = [];
          this.noMore = false;
          this.getSupplierRecordInfoFun(this.activeTab);
        } else {
          this.$message.error(res.msg || (isEdit ? "修改竞价失败" : "提交竞价失败"));
        }
      } catch (error) {
        console.error(isEdit ? "修改竞价失败：" : "提交竞价失败：", error);
        this.$message.error(error.message || (isEdit ? "修改竞价失败" : "提交竞价失败"));
      }
    },
  },
  watch: {
    // 监听 message 的变化
    activeTab: function (newVal) {
      // 将 activeTab 同步到路由 query，确保返回页面时能恢复 tab 状态
      if (this.$route.query.route !== newVal) {
        this.$router.replace({
          path: this.$route.path,
          query: { ...this.$route.query, route: newVal },
        });
      }
      this.pageNum = 1;
      this.orderList = [];
      this.noMore = false;
      this.getSupplierRecordInfoFun(newVal);
    },
  },
};
</script>

<style>
/* 引入产品需求发布弹窗公共样式 */
@import "~@/assets/css/publish-dialog.css";
</style>

<style scoped>
.info-manage-supplier {
  background: #ffffff;
  border-radius: 8px;
  padding: 0 0px 27px 0px;
}
.info-tabs {
  padding: 0 38px;
  position: sticky;
  top: 0;
  background: #ffffff;
  z-index: 10;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.info-tabs >>> .el-tabs__item {
  font-size: 18px;
  color: #999999;
  height: 60px;
  line-height: 60px;
}

.info-tabs >>> .el-tabs__item.is-active {
  color: #1869ff;
  font-weight: 500;
}

.info-tabs >>> .el-tabs__active-bar {
  background-color: #1869ff;
}

.info-manage-supplier /deep/ .el-tabs__nav-wrap::after {
  height: 0;
}

.info-manage-supplier /deep/ .el-tabs__header {
  margin: 0;
}
.bar-line {
  width: 100%;
  height: 1px;
  background: #e5e5e5;
  position: sticky;
  top: 60px;
  z-index: 10;
}

/* ---------- 表格区域 ---------- */
.info-table {
  padding: 0 20px;
  margin-top: 14px;
  font-size: 14px;
  color: #333333;
}

.table-row {
  display: flex;
  align-items: center;
  padding: 0 9px;
}

.cell {
  padding: 18px 8px 18px 0;
  box-sizing: border-box;
  word-break: break-all;
}

.cell-publisher {
  width: 12%;
  display: flex;
  align-items: center;
}
.cell-image {
  width: 9%;
}
.cell-name {
  width: 9%;
}
.cell-category {
  width: 9%;
}
.cell-company {
  width: 15%;
}
.cell-contact {
  width: 12%;
}
.cell-remark {
  width: 12%;
}
.cell-status {
  width: 12%;
}
.cell-action {
  width: 10%;
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: center;
}

/* 表头 */
.table-head {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 500;
  font-size: 14px;
  color: #333333;
  background: #f7f7f7;
  padding: 10px 16px;
  margin-bottom: 6px;
}
.table-head .cell {
  padding: 0;
}

/* 订单分组 */
.order-group {
  border: 1px solid #ebebeb;
  border-radius: 2px;
  margin-bottom: 10px;
  overflow: hidden;
  line-height: 17px;
  color: #666666;
  font-weight: 400;
}

.order-id {
  background: #f7f7f7;
  color: #666666;
  font-size: 12px;
  font-weight: 400;
  padding: 6px 9px;
  border-bottom: 1px solid #ebebeb;
}

.table-body {
  background: #ffffff;
}

/* 发布人 */
.avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 6px;
}

/* 产品图占位 */
.product-img {
  width: 48px;
  height: 48px;
  border-radius: 6px;
}

/* 操作按钮 */
.op-btn {
  width: 80px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #ffffff;
  border: 1px solid #e1e1e1;
  border-radius: 4px;
  color: #333333;
  font-size: 14px;
  cursor: pointer;
  padding: 0;
}
.op-btn:hover {
  color: #1869ff;
  border-color: #1869ff;
}

.order-detail-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 24px;
  align-content: flex-start;
  margin-top: 35px;
}
.order-detail-grid .detail-item {
  display: flex;
  align-items: flex-start;
  font-size: 16px;
  width: calc(50% - 12px);
}
.order-detail-grid .detail-label {
  color: #666;
  flex-shrink: 0;
}
.order-detail-grid .detail-value {
  color: #333;
  word-break: break-all;
}
.order-detail-img {
  width: 72px;
  height: 72px;
  margin-right: 8px;
  border-radius: 4px;
}

/* 订单滚动列表 */
.order-list {
  max-height: 70vh;
  overflow-y: auto;
}

/* 加载更多提示 */
.loading-more {
  text-align: center;
  padding: 16px 0;
  font-size: 14px;
  color: #999999;
}
</style>
